import { FormatGroup } from "./types";

/**
 * Maps format values to Colab notebook URLs.
 * Some formats have different notebooks per dataset type (e.g., OD vs instance-seg).
 * Source of truth: datasetVersionDownload.js:363-422
 */
const notebookUrls: Record<string, string | Record<string, string>> = {
    "yolov5pytorch": {
        "object-detection":
            "https://colab.research.google.com/github/roboflow/notebooks/blob/main/notebooks/train-yolov5-object-detection-on-custom-data.ipynb",
        "instance-segmentation":
            "https://colab.research.google.com/github/roboflow/notebooks/blob/main/notebooks/train-yolov5-instance-segmentation-on-custom-data.ipynb"
    },
    "yolov8": {
        "object-detection":
            "https://colab.research.google.com/github/roboflow/notebooks/blob/main/notebooks/train-yolov8-object-detection-on-custom-dataset.ipynb",
        "instance-segmentation":
            "https://colab.research.google.com/github/roboflow/notebooks/blob/main/notebooks/train-yolov8-instance-segmentation-on-custom-dataset.ipynb"
    },
    "yolov9":
        "https://colab.research.google.com/github/roboflow/notebooks/blob/main/notebooks/train-yolov9-object-detection-on-custom-dataset.ipynb",
    "yolov11": {
        "object-detection":
            "https://colab.research.google.com/github/roboflow-ai/notebooks/blob/main/notebooks/train-yolo11-object-detection-on-custom-dataset.ipynb",
        "instance-segmentation":
            "https://colab.research.google.com/github/roboflow-ai/notebooks/blob/main/notebooks/train-yolo11-instance-segmentation-on-custom-dataset.ipynb"
    },
    "yolov12":
        "https://colab.research.google.com/github/roboflow-ai/notebooks/blob/main/notebooks/train-yolov12-object-detection-model.ipynb",
    "yolo26": {
        "object-detection":
            "https://colab.research.google.com/github/roboflow-ai/notebooks/blob/main/notebooks/train-yolo26-object-detection-on-custom-dataset.ipynb",
        "instance-segmentation":
            "https://colab.research.google.com/github/roboflow-ai/notebooks/blob/main/notebooks/train-yolo26-instance-segmentation-on-custom-dataset.ipynb"
    },
    "paligemma":
        "https://colab.research.google.com/github/roboflow-ai/notebooks/blob/main/notebooks/how-to-finetune-paligemma-on-detection-dataset.ipynb",
    "florence2-od":
        "https://colab.research.google.com/github/roboflow-ai/notebooks/blob/main/notebooks/how-to-finetune-florence-2-on-detection-dataset.ipynb"
};

export function resolveNotebookUrl(formatValue: string, datasetType?: string): string | undefined {
    const entry = notebookUrls[formatValue];
    if (!entry) return undefined;
    if (typeof entry === "string") return entry;
    return entry[datasetType || "object-detection"] || Object.values(entry)[0];
}

/** Enriches format groups with resolved {@link FormatOption.notebookUrl} fields. */
export function withNotebookUrls(groups: FormatGroup[], datasetType?: string): FormatGroup[] {
    const hasAny = groups.some((g) => g.formats.some((fmt) => notebookUrls[fmt.value]));
    if (!hasAny) return groups;
    return groups.map((g) => ({
        ...g,
        formats: g.formats.map((fmt) => {
            const url = resolveNotebookUrl(fmt.value, datasetType);
            return url ? { ...fmt, notebookUrl: url } : fmt;
        })
    }));
}
